import type { RouteLocationNormalized } from '#vue-router';

export function isRequiresAuth(route: RouteLocationNormalized) {
  return route.matched.some((record) => record.meta.requiresAuth);
}

export const isArray = Array.isArray;
export const IN_BROWSER: boolean = typeof window !== 'undefined';

export const isObject = (val: unknown): val is Record<any, any> =>
  val !== null && typeof val === 'object';

export const isString = (value: unknown): boolean => {
  return typeof value === 'string';
};

export const isTouchDevice = (): boolean => {
  return typeof window !== 'undefined' && 'ontouchstart' in window;
};

export const has = (obj: Record<string, any>, prop: string): boolean => {
  return Object.prototype.hasOwnProperty.call(obj, prop);
};

export const uniqueArrayOfObject = (arrayObjects: any[], keyToBeUnique: string): any[] => {
  return arrayObjects.reduce((result, item) => {
    const alreadyInResult = result.find(
      (resultItem: any) => resultItem[keyToBeUnique] === item[keyToBeUnique],
    );

    if (!alreadyInResult) {
      result.push(item);
    }

    return result;
  }, []);
};

export const isRetina = (): boolean =>
  typeof window !== 'undefined' ? window.devicePixelRatio >= 2 : false;
